import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-5" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { style: {"width":"400px"} }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  class: "nav bg-light rounded-pill px-2 py-1",
  "data-kt-buttons": "true",
  "data-kt-initialized": "1"
}
const _hoisted_6 = {
  class: "d-flex",
  style: {"justify-content":"flex-end"}
}
const _hoisted_7 = {
  key: 0,
  class: "d-flex",
  style: {"justify-content":"flex-end"}
}
const _hoisted_8 = { class: "me-5" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { key: 2 }

import { getUserTenancy, tenancies } from "@/core/types/TenantTypes";
import UserDocuments from "@/projects/tenant/modules/users/components/UserDocuments.vue";
import { nextTick, ref } from "vue";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import SimpleForm from "@/components/SimpleForm.vue";
import UserStart from "@/projects/tenant/modules/users/components/UserStart.vue";
import UserInfos from "@/projects/tenant/modules/users/components/UserInfos.vue";
import UserFinancial from "@/projects/tenant/modules/users/components/UserFinancial.vue";
import UserAuFinancial from "@/projects/tenant/modules/users/components/UserAuFinancial.vue";
import UserQuizs from "@/projects/tenant/modules/users/components/UserQuizs.vue";
import UserAgreement from "@/projects/tenant/modules/users/components/UserAgreement.vue";
import SimpleForm2 from "@/components/SimpleForm.vue";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";
import ConfirmBox from "@/components/ConfirmBox.vue";
import { useStore } from "@/store";
import RejectReasonBox from "@/components/RejectReasonBox.vue";
import { useI18n } from "vue-i18n";
import ChangeSiteModal from "@/projects/tenant/modules/users/components/modal/ChangeSiteModal.vue";
import GlobalService from "@/projects/tenant/services/TenantGlobalService";
import { ReferralServiceTypes } from "@/core/types/ReferralServiceTypes";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import { ElNotification } from "element-plus";
import ShowMoveModal from "./ShowMoveModal.vue";
const enum VerificationTab {
  Started = "Started",
  Info = "Info",
  Financial = "Financial",
  Quiz = "Quiz",
  Agreement = "Agreement",
  Document = "Document",
  PersonalInfos = "Personal",
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UserVerifyDocModal',
  emits: ["user-approved", "user-moved"],
  setup(__props, { expose: __expose, emit: emits }) {

const { t } = useI18n();
const store = useStore();
const user = store.state.AuthModule.user;
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const changeSiteModalRef = ref<InstanceType<typeof ChangeSiteModal>>();
const referInfo = ref<any>({});


const isLoading = ref(true);
const currentTab = ref(VerificationTab.Document);
const verificationDetails = ref<any>({});
const showSiteID = ref("");
const handleUserVerificationStatusChange = (
  _status: VerificationStatusTypes
) => {
  verificationDetails.value.status = _status;
  // nextTick(() => loadUserVerifications(verificationDetails.value.id));
};
const moveModalRef = ref<InstanceType<typeof ShowMoveModal>>();
const showMoveModal = () => {
  moveModalRef.value?.show(verificationDetails.value.partyId, user);
};

const loadUserVerifications = async (id) => {
  try {
    isLoading.value = true;
    verificationDetails.value = await UserService.getVerificationById(id);
    showSiteID.value = t("type.siteType." + verificationDetails.value.siteId);
  } catch (error) {
    ElNotification.error(error);
  } finally {
    isLoading.value = false;
  }
};

const confirmBoxRef = ref<InstanceType<typeof ConfirmBox>>();
const rejectReasonBoxRef = ref<InstanceType<typeof RejectReasonBox>>();
const openApprovePanel = () => {
  confirmBoxRef.value?.show(() =>
    UserService.putUserToApproved(verificationDetails.value.id)
      // Promise.resolve()
      .then(() => ElNotification.success("User verification approved!"))
      .then(() => confirmBoxRef.value?.hide())
      .then(() => hide())
      .then(() => emits("user-approved"))
  );
};

const changeVerifyingState = async (_status: VerificationStatusTypes) => {
  if (verificationDetails.value.status === _status) {
    return;
  }

  try {
    isLoading.value = true;
    await {
      [VerificationStatusTypes.AwaitingReview]: () =>
        UserService.putUserToAwaitingReview(verificationDetails.value.id),
      [VerificationStatusTypes.UnderReview]: () =>
        UserService.putUserToUnderReview(verificationDetails.value.id),
      [VerificationStatusTypes.AwaitingApprove]: () =>
        UserService.putUserToAwaitingApprove(verificationDetails.value.id),
      [VerificationStatusTypes.Rejected]: () =>
        UserService.putUserToRejected(verificationDetails.value.id),
    }[_status]();
    verificationDetails.value.status = _status;
  } catch (err) {
    ElNotification.error(err);
  } finally {
    isLoading.value = false;
  }
};

// https://pro.t.api.mybcr.dev/api/v1/tenant/verification/137/reject-notice

const openRejectPanel = () => {
  confirmBoxRef.value?.show(
    () =>
      UserService.sendRejectDocumentEmail(verificationDetails.value.id)
        // Promise.resolve()
        .then(() =>
          ElNotification.success("User verification reject email sent!")
        )
        .then(() => confirmBoxRef.value?.hide())
        .then(() => hide())
        .then(() => emits("user-approved")),
    "Ready to send reject notice email?"
  );
};

const handleSelect = (key: VerificationTab, keyPath: string[]) => {
  currentTab.value = key;
};

const updateSiteID = async (_siteId: number) => {
  showSiteID.value = t("type.siteType." + _siteId);
};

const getReferCodeDetail = async () => {
  if (
    verificationDetails.value.started !== null &&
    verificationDetails.value.started.referral !== ""
  ) {
    referInfo.value = await GlobalService.getReferralCodeAccountInfo(
      verificationDetails.value.started.referral
    );
    referInfo.value.serviceFor = getAccountRoleDesignatedByReferCode(
      referInfo.value.serviceType
    );
  }
};

const getAccountRoleDesignatedByReferCode = (serviceType) =>
  ({
    [ReferralServiceTypes.Broker]: AccountRoleTypes.IB,
    [ReferralServiceTypes.Agent]: AccountRoleTypes.IB,
    [ReferralServiceTypes.Client]: AccountRoleTypes.Client,
    // for legacy data
    [200]: AccountRoleTypes.IB,
    [300]: AccountRoleTypes.IB,
    [400]: AccountRoleTypes.Client,
  }[serviceType] ?? AccountRoleTypes.Client);

const show = async (id: number) => {
  await loadUserVerifications(id);
  try {
    await getReferCodeDetail();
  } catch (error) {
    // MsgPrompt.error(error);
  }

  // verificationDetails change in loadUserVerifications,
  // wait for nextTick to show modal to display the proper verification details
  await nextTick();
  modalRef.value?.show();
};
const openDelayReviewPanel = () => {
  confirmBoxRef.value?.show(() =>
    UserService.putUserToDelayReview(verificationDetails.value.id)
      // Promise.resolve()
      .then(() => ElNotification.success("User verification delay review!"))
      .then(() => confirmBoxRef.value?.hide())
      .then(() => hide())
      .then(() => emits("user-approved"))
  );
};
const hide = () => {
  modalRef.value?.hide();
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SimpleForm2, {
      ref_key: "modalRef",
      ref: modalRef,
      "min-height": 700,
      "min-width": 1300,
      title: _ctx.$t('title.verifications'),
      "is-loading": isLoading.value,
      "disable-submit": 
      verificationDetails.value.status !== _unref(VerificationStatusTypes).AwaitingApprove
    ,
      "disable-discard": 
      verificationDetails.value.status !== _unref(VerificationStatusTypes).AwaitingApprove
    ,
      "save-title": _ctx.$t('action.approve'),
      submit: openApprovePanel,
      discard: openRejectPanel,
      "discard-color": "danger",
      "discard-title": _ctx.$t('action.reject'),
      "append-body": "",
      "delay-review": true,
      "delay-review-handler": openDelayReviewPanel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_menu, {
                "default-active": currentTab.value,
                class: "w-100 mb-5",
                mode: "horizontal",
                onSelect: handleSelect
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    index: VerificationTab.Document
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("title.document")), 1)
                    ]),
                    _: 1
                  }, 8, ["index"]),
                  _createVNode(_component_el_sub_menu, { index: "1111111" }, {
                    title: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.verficationInfos")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: VerificationTab.Started
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("fields.started")), 1)
                        ]),
                        _: 1
                      }, 8, ["index"]),
                      _createVNode(_component_el_menu_item, {
                        index: VerificationTab.Financial
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("fields.financial")), 1)
                        ]),
                        _: 1
                      }, 8, ["index"]),
                      _createVNode(_component_el_menu_item, {
                        index: VerificationTab.Quiz
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("fields.quiz")), 1)
                        ]),
                        _: 1
                      }, 8, ["index"]),
                      _createVNode(_component_el_menu_item, {
                        index: VerificationTab.Agreement
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("fields.agreement")), 1)
                        ]),
                        _: 1
                      }, 8, ["index"]),
                      _createVNode(_component_el_menu_item, {
                        index: VerificationTab.Info
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("fields.info")), 1)
                        ]),
                        _: 1
                      }, 8, ["index"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["default-active"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              (
              verificationDetails.value.status !==
              _unref(VerificationStatusTypes).AwaitingReview
            )
                ? (_openBlock(), _createBlock(_component_UserInfo, {
                    key: 0,
                    user: _unref(user),
                    sub: _ctx.$t('fields.operator'),
                    class: "me-2"
                  }, null, 8, ["user", "sub"]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-warning text-black-50 me-5",
                onClick: openRejectPanel
              }, _toDisplayString(_ctx.$t("action.sendDocumentsRejectionEmail")), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link btn btn-active btn-active-dark fw-bold btn-color-gray-600 py-2 px-5 m-1 rounded-pill", {
                active:
                  verificationDetails.value.status ===
                  _unref(VerificationStatusTypes).AwaitingReview,
              }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (
                changeVerifyingState(_unref(VerificationStatusTypes).AwaitingReview)
              )),
                  style: {"transition":"background-color 0.3s ease-in-out 0s"}
                }, _toDisplayString(_ctx.$t("status.pending")), 3),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link btn btn-active btn-active-dark fw-bold btn-color-gray-600 py-2 px-5 m-1 rounded-pill", {
                active:
                  verificationDetails.value.status ===
                  _unref(VerificationStatusTypes).UnderReview,
              }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeVerifyingState(_unref(VerificationStatusTypes).UnderReview))),
                  style: {"transition":"background-color 0.3s ease-in-out 0s"}
                }, _toDisplayString(_ctx.$t("status.reviewing")), 3),
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link btn btn-active btn-active-dark fw-bold btn-color-gray-600 py-2 px-5 m-1 rounded-pill", {
                active:
                  verificationDetails.value.status ===
                  _unref(VerificationStatusTypes).AwaitingApprove,
              }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
                changeVerifyingState(_unref(VerificationStatusTypes).AwaitingApprove)
              )),
                  style: {"transition":"background-color 0.3s ease-in-out 0s"}
                }, _toDisplayString(_ctx.$t("status.reviewed")), 3)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.$can('TenantAdmin'))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "me-9",
                  type: "warning",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showMoveModal()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.moveUser")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('fields.site'),
              prop: "siteID",
              style: {"width":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: showSiteID.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showSiteID).value = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_button, {
              class: "ms-4",
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (
            changeSiteModalRef.value?.show(
              verificationDetails.value.partyId,
              verificationDetails.value.siteId
            )
          ))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
              ]),
              _: 1
            })
          ]),
          (
          verificationDetails.value.started && verificationDetails.value.started.referral
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(" Referral Code: "),
                    _createElementVNode("b", null, _toDisplayString(verificationDetails.value.started.referral), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode(" Sales Code: "),
                    (Object.keys(referInfo.value).length != 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_10, _toDisplayString(referInfo.value.salesAccountCode), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(" Open For: "),
                    (Object.keys(referInfo.value).length != 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_12, _toDisplayString(_ctx.$t(`type.accountRole.${referInfo.value.serviceFor}`)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode(" IB Group: "),
                    (Object.keys(referInfo.value).length != 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_13, _toDisplayString(referInfo.value.accountGroupName), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (!isLoading.value && VerificationTab.Started === currentTab.value)
              ? (_openBlock(), _createBlock(UserStart, {
                  key: 0,
                  "verification-details": verificationDetails.value
                }, null, 8, ["verification-details"]))
              : _createCommentVNode("", true),
            (!isLoading.value && VerificationTab.Info === currentTab.value)
              ? (_openBlock(), _createBlock(UserInfos, {
                  key: 1,
                  "verification-details": verificationDetails.value
                }, null, 8, ["verification-details"]))
              : _createCommentVNode("", true),
            (!isLoading.value && VerificationTab.Financial === currentTab.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_unref(getUserTenancy)() === _unref(tenancies).au)
                    ? (_openBlock(), _createBlock(UserAuFinancial, {
                        key: 0,
                        "verification-details": verificationDetails.value
                      }, null, 8, ["verification-details"]))
                    : (_openBlock(), _createBlock(UserFinancial, {
                        key: 1,
                        "verification-details": verificationDetails.value
                      }, null, 8, ["verification-details"]))
                ]))
              : _createCommentVNode("", true),
            (!isLoading.value && VerificationTab.Quiz === currentTab.value)
              ? (_openBlock(), _createBlock(UserQuizs, {
                  key: 3,
                  "verification-details": verificationDetails.value
                }, null, 8, ["verification-details"]))
              : _createCommentVNode("", true),
            (!isLoading.value && VerificationTab.Agreement === currentTab.value)
              ? (_openBlock(), _createBlock(UserAgreement, {
                  key: 4,
                  "verification-details": verificationDetails.value
                }, null, 8, ["verification-details"]))
              : _createCommentVNode("", true),
            (!isLoading.value && VerificationTab.Document === currentTab.value)
              ? (_openBlock(), _createBlock(UserDocuments, {
                  key: 5,
                  "verification-details": verificationDetails.value,
                  verifyOperation: true,
                  onUpdateVerificationDetails: _cache[6] || (_cache[6] = ($event: any) => (
            loadUserVerifications(verificationDetails.value.id)
          )),
                  partyId: verificationDetails.value.partyId,
                  onUserVerificationStateChange: handleUserVerificationStatusChange,
                  height: "625px"
                }, null, 8, ["verification-details", "partyId"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(ConfirmBox, {
          ref_key: "confirmBoxRef",
          ref: confirmBoxRef,
          "is-loading": isLoading.value,
          "cancel-color": "reject"
        }, null, 8, ["is-loading"]),
        _createVNode(RejectReasonBox, {
          ref_key: "rejectReasonBoxRef",
          ref: rejectReasonBoxRef
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title", "is-loading", "disable-submit", "disable-discard", "save-title", "discard-title"]),
    _createVNode(ChangeSiteModal, {
      ref_key: "changeSiteModalRef",
      ref: changeSiteModalRef,
      onUpdateSiteID: updateSiteID
    }, null, 512),
    _createVNode(ShowMoveModal, {
      ref_key: "moveModalRef",
      ref: moveModalRef,
      onUserMoved: _cache[7] || (_cache[7] = ($event: any) => (emits('user-moved')))
    }, null, 512)
  ], 64))
}
}

})